import translate from '@/services/translate';
import messageDefinitions from './message-definitions.json';

export const alerts = [];

const listeners = [];

const DEFAULT_ALERT_TYPE = 'info';
const DANGER_ALERT_TYPE = 'danger';
let alertId = 0;

// eslint-disable-next-line import/prefer-default-export
export const alertModes = {
  ALERT: 'alert',
  TOAST: 'toast',
};

const DEFAULT_NOTIFICATION_MODE = alertModes.ALERT;

class Alert {
  constructor(config) {
    alertId += 1;
    this.id = alertId;
    if (typeof config === 'string') {
      this.message = config;
      this.type = DEFAULT_ALERT_TYPE;
      return;
    }

    this.setProperties(config);

    this.titleParams = config.titleParams;
    this.messageParams = config.messageParams;
    this.type = this.type || DEFAULT_ALERT_TYPE;
    this.mode = this.mode || DEFAULT_NOTIFICATION_MODE;
    this.autoDismissible = this.autoDismissible != null
        ? this.autoDismissible
        : this.type !== 'danger';

    this.setMessageList(config);
  }

  setProperties(config) {
    if (!config.code) {
      const fallbackTitle = config.isMSIS && config.type === DANGER_ALERT_TYPE
          ? translate('message-warning.error')
          : '';
      this.title = config.title || fallbackTitle;
      this.message = config.message;
      this.confirmation = config.confirmation;
      this.type = config.type;
      this.mode = config.mode;
      this.autoDismissible = config.autoDismissible;
      return;
    }

    this.code = config.code.toUpperCase();
    this.title = config.title
      || (messageDefinitions[this.code].hasTitle
        ? `messages.${this.code.toUpperCase()}.title`
        : null);
    this.message = config.message || `messages.${this.code.toUpperCase()}.message`;
    this.type = config.type || messageDefinitions[this.code].type;
    this.mode = config.mode;
  }

  setMessageList(config) {
    if (config.messageList) {
      this.messageList = config.messageList.map(messageItem => ({
        code: messageItem.code,
        message:
          messageItem.message
          || `messages.${messageItem.code.toUpperCase()}.message`,
        messageParams: messageItem.messageParams,
      }));
    }
  }

  dismiss() {
    alerts.splice(alerts.indexOf(this), 1);
  }
}

export function onNewAlert(listener) {
  listeners.push(listener);
  return () => listeners.splice(listeners.indexOf(listener), 1);
}

export function pushAlert(alert) {
  const alertWithSameContent = alerts.find(a => a.message === alert.message);

  if (alertWithSameContent) {
    return null;
  }

  const newAlert = new Alert(alert);
  alerts.push(newAlert);
  listeners.forEach(listener => listener(newAlert));

  return newAlert;
}
